/**
 * @generated SignedSource<<36bfdcfb95a7d029e15298bcffbd8a23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type resizablePrintAreaQuery$variables = Record<PropertyKey, never>;
export type resizablePrintAreaQuery$data = {
  readonly resizablePresets: {
    readonly nodes: ReadonlyArray<{
      readonly height: number;
      readonly id: string;
      readonly name: string | null;
      readonly resizablePresetID: number;
      readonly width: number;
    }> | null;
  } | null;
};
export type resizablePrintAreaQuery = {
  response: resizablePrintAreaQuery$data;
  variables: resizablePrintAreaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResizablePresetsConnection",
    "kind": "LinkedField",
    "name": "resizablePresets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResizablePreset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resizablePresetID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "width",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "height",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "resizablePrintAreaQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "resizablePrintAreaQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "be363200ed8756dcf042544b6d7f90af",
    "id": null,
    "metadata": {},
    "name": "resizablePrintAreaQuery",
    "operationKind": "query",
    "text": "query resizablePrintAreaQuery {\n  resizablePresets {\n    nodes {\n      id\n      resizablePresetID\n      name\n      width\n      height\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "641b62c22a46419c8b7f5ffcc76b105f";

export default node;
